import { configureStore } from "@reduxjs/toolkit";
import sectionsReducers from "../components/pages/createplan/SectionsSlice";
import profileReducer from "../components/pages/createplan/ProfileSlice";
import utilsSlice from "../components/pages/createplan/UtilsSlice";
import authReducer from "./authSlice";
import analyticsReducer from "../components/pages/analytics/analyticsSlice";
import subAccountsReducer from "../components/pages/representatives/subAccountsSlice";
import crmReducer from "../components/pages/crm/crmSlice";
import toastReducer from "./toastSlice";
import dispositionsReducer from "../components/pages/agents/dispositionsSlice";
import flowBuilderReducer from "../components/pages/flowbuilder/flowBuilderSlice";
import aiUsageReducer     from "../components/pages/ai/aiUsageSlice";
import knowledgeReducer   from "../components/pages/ai/knowledgeSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    sections: sectionsReducers,
    profile: profileReducer,
    utils: utilsSlice,
    analytics: analyticsReducer,
    subAccounts: subAccountsReducer,
    crm: crmReducer,
    toast: toastReducer,
    dispositions: dispositionsReducer,
    flowBuilder: flowBuilderReducer,
    aiUsage:     aiUsageReducer,
    knowledge:   knowledgeReducer,
  },
});

export default store;
